// TRTC错误码映射表 - 基于官方v5.0文档
const TRTC_ERROR_MAP = {
  // 参数错误 (5000系列)
  '5000': '调用接口时传入了不满足API要求的参数',
  '5001': '未填必填参数',
  '5002': '参数类型不对',
  '5003': '参数传了空值',
  '5004': '参数原型不对',
  '5005': '参数不在规定的取值范围',
  '5006': '参数要大于等于0',
  '5007': '参数要大于最小值',
  '5008': '参数要小于最大值',
  '5009': '该elementId在页面上找不到，或者查找时不在页面上',
  '5010': '传入的参数不是HTMLElement类型',
  '5011': 'streamId不符合规范',
  '5012': '传入roomId的范围不符合规范[1, 4294967294]',
  '5013': '传入的strRoomId类型不是合法的string',
  '5014': '当userId不是"*"时，需要传入streamType',
  '5015': '未填写roomId或strRoomId，roomId和strRoomId必须填写一个',
  '5016': 'roomId必须是数字类型，当前传入了字符串类型',
  '5017': 'arraybuffer的size不能为0',
  '5018': 'arraybuffer的size超过允许的范围',

  // 无效操作 (5100系列)
  '5100': '调用接口时，不满足API的前提要求',
  '5101': '在未进房的情况下调用API',
  '5102': '远端用户不存在',
  // '5103': '远端流类型不存在',
  '5103': '当前选中用户未打开摄像头，无法切换大屏显示',
  '5104': '重复调用API',
  '5105': '在未开启摄像头的情况下调用API',
  '5106': '在未开启麦克风的情况下调用API',
  '5107': '观众角色不能调用此API',
  '5108': '需要在TRTC.create({enableSEI: true})打开SEI功能',
  '5109': '需要在发送SEI之前推视频流',

  // 环境不支持 (5200系列)
  '5200': '当前环境不支持该功能',
  '5201': '当前页面协议非HTTPS，不支持音视频采集能力',
  '5202': '当前浏览器不支持WebRTC能力，浏览器版本过低',
  '5203': '浏览器不支持H264编码能力',
  '5204': '浏览器不支持H264解码能力',
  '5205': '浏览器不支持屏幕分享能力',
  '5206': '浏览器不支持小流编码能力',
  '5207': '浏览器不支持SEI收发能力',
  '5208': '浏览器不支持WebGL',
  '5209': '当前版本的浏览器不支持该功能，请升级到最新版本',
  '5210': '当前版本的浏览器不支持该插件，请升级到最新版本',

  // 设备错误 (5300系列) - 这是你关心的麦克风/摄像头问题
  '5300': '获取设备或者采集音视频出现异常',
  '5301': '找不到满足请求参数的媒体设备类型（包括：音频、视频、屏幕分享）',
  '5302': '用户拒绝了浏览器采集麦克风、摄像头、屏幕分享的请求，或系统关闭了浏览器权限',
  '5303': '尽管用户已经授权使用设备，但由于硬件、浏览器或系统问题导致设备无法访问',
  '5304': 'cameraId/microphoneId参数的值无效',
  '5305': '当前页面未产生交互，页面不是完全激活的',
  '5306': '由于系统安全策略禁止使用设备',
  '5307': '由于某些未知原因导致设备无法被使用',
  '5308': '摄像头采集异常，经过SDK重试仍然无法恢复采集',
  '5309': '麦克风采集异常，经过SDK重试仍然无法恢复采集',
  '5310': '麦克风采样率异常，无法使用音频处理插件',

  // 服务器错误 (5400系列)
  '5400': '收到服务端返回的异常数据',
  '5401': '该功能需要购买套餐',
  '-8': 'sdkAppId不正确，请检查sdkAppId是否正确填写',
  '-10012': '未传入roomId或者roomId不符合规范',
  '-10013': '客户服务欠费',
  '-100024': '未开通TRTC服务导致进房失败',
  '70001': 'userSig过期，请尝试重新生成',
  '70002': 'userSig长度为0，请确认签名计算是否正确',
  '70003': 'userSig校验失败，请确认userSig内容是否被截断',
  '70004': 'userSig校验失败，请确认userSig内容是否被截断',
  '70005': 'userSig校验失败，通过工具来验证生成的userSig是否正确',
  '70006': 'userSig校验失败，通过工具来验证生成的userSig是否正确',
  '70007': 'userSig校验失败，通过工具来验证生成的userSig是否正确',
  '70008': 'userSig校验失败，通过工具来验证生成的userSig是否正确',
  '70009': '用业务公钥验证userSig失败',
  '70010': 'userSig校验失败，通过工具来验证生成的userSig是否正确',
  '70013': 'userSig中userId与请求时的userId不匹配',
  '70014': 'userSig中sdkAppId与请求时的sdkAppId不匹配',
  '70052': 'userSig已经失效，请重新生成',

  // 操作失败 (5500系列)
  '5500': 'SDK经过多次重试仍然无法解决的异常',
  '5501': '防火墙受限：无法建立媒体连接',
  '5502': '重进房失败：userSig过期导致重进房失败',
  '5503': '重进房失败：userSig过期导致重进房失败',
  '5505': '视频编码失败，通常是设备不支持h264编码',
  '5506': '音频编码失败',
  '5507': '视频解码失败，通常是设备不支持h264解码',
  '5508': '音频解码失败',

  // 操作中止 (5998)
  // '5998': '中止API执行',

  // 未知错误 (5999)
  '5999': '未知错误或者未被定义的错误'
};

// 设备特定错误映射（浏览器原生错误）
const DEVICE_ERROR_MAP = {
  'NotAllowedError': '用户拒绝了设备权限请求',
  'NotFoundError': '未找到指定的媒体设备',
  'NotReadableError': '设备被占用或无法访问',
  'OverconstrainedError': '无法满足指定的约束条件',
  'TypeError': '约束条件参数错误',
  'PermissionDeniedError': '权限被拒绝，请在浏览器设置中允许设备访问',
  'InvalidStateError': '当前页面未产生交互，请先与页面交互',
  'SecurityError': '由于系统安全策略禁止使用设备',
  'AbortError': '由于某些未知原因导致设备无法被使用'
};

export class TRTCErrorHandler {
  /**
   * 获取错误中文描述
   */
  static getErrorMessage(error) {
    console.log('error:', error);
    console.log('error:', error.code);
    if (!error){
      return '未知错误';
    }
    // // 优先处理TRTC错误码
    // if (error.code && TRTC_ERROR_MAP[error.code]) {
    //   // 如果有extraCode，尝试使用更具体的描述
    //   if (error.extraCode && TRTC_ERROR_MAP[error.extraCode]) {
    //     return TRTC_ERROR_MAP[error.extraCode];
    //   }
    //   return TRTC_ERROR_MAP[error.code];
    // }
    //
    // // 处理extraCode
    // if (error.extraCode && TRTC_ERROR_MAP[error.extraCode]) {
    //   return TRTC_ERROR_MAP[error.extraCode];
    // }
    //
    // // 处理字符串错误码
    // if (typeof error === 'string' && TRTC_ERROR_MAP[error]) {
    //   return TRTC_ERROR_MAP[error];
    // }
    //
    // // 处理设备错误
    // if (error.name && DEVICE_ERROR_MAP[error.name]) {
    //   return DEVICE_ERROR_MAP[error.name];
    // }

    // 处理错误消息
    if (error.message) {
      return this.parseErrorMessage(error.message);
    }

    return '发生未知错误，请重试';
  }

  /**
   * 解析错误消息
   */
  static parseErrorMessage(message) {
    const lowerMsg = message.toLowerCase();
    console.log('message == = =  = ', message)
    console.log('lowerMsg == = =  = ', lowerMsg)
    if (lowerMsg.includes('null')) {
      return '当前没在预约的时间内';
    }
    if (lowerMsg.includes('not support screen share')) {
      return '手机端暂不支持共享屏幕';
    }
    if (lowerMsg.includes('not publishing')) {
      return '当前选中用户未打开摄像头，无法切换大屏显示';
    }
    if(lowerMsg.includes('no microphone')) {
      return '未检测到麦克风，您需要安装个麦克风';
    }
    if(lowerMsg.includes('no camera')) {
      return '未检测到摄像头，您需要安装个摄像头';
    }
    if(lowerMsg.includes('disabled screen share')) {
      return '已取消屏幕分享';
    }
    if(lowerMsg.includes('audio decode failed')) {
      return '设备（麦克风、摄像头）权限被拒绝，请在浏览器设置中允许设备访问';
    }
    if (lowerMsg.includes('permission') || lowerMsg.includes('denied')) {
      const textArr = []
      if(lowerMsg.includes('microphone')) {
        textArr.push('麦克风')
      }
      if(lowerMsg.includes('camera')) {
        textArr.push('摄像头')
      }
      return '设备（'+textArr.join('、')+'）权限被拒绝，请在浏览器设置中允许设备访问';
    }
    if((lowerMsg.includes('camera') || lowerMsg.includes('video')) && lowerMsg.includes('not started')) {
      return '摄像头未打开，暂不支持切换'
    }
    if (lowerMsg.includes('camera') || lowerMsg.includes('video')) {
      return '摄像头设备异常，请检查摄像头连接和权限';
    }

    if (lowerMsg.includes('network') || lowerMsg.includes('connection')) {
      return '网络连接异常，请检查网络设置';
    }

    if (lowerMsg.includes('not found') || lowerMsg.includes('找不到')) {
      return '设备未找到，请检查设备连接';
    }

    if (lowerMsg.includes('not allowed')) {
      return '操作不被允许，请检查权限设置';
    }

    // 对于已知的英文错误直接翻译
    const knownErrors = {
      'failed to execute': '执行失败',
      'invalid constraint': '无效的参数约束',
      'could not start video source': '无法启动视频源',
      'could not start audio source': '无法启动音频源',
      'requested device not found': '请求的设备未找到'
    };

    for (const [key, value] of Object.entries(knownErrors)) {
      if (lowerMsg.includes(key)) {
        return value;
      }
    }

    return `操作失败: ${message}`;
  }

  /**
   * 显示错误提示
   */
  static showError(error, vm, customMessage = null) {
    const message = customMessage || this.getErrorMessage(error);
    // console.error('TRTC Error:', error, 'Message:', message);

    // 使用UI框架显示错误提示
    if (vm && vm.$message) {
      vm.$message.warning(message);
    } else {
      // 原生alert
      alert(message);
    }

    return message;
  }
}
